"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("@material-ui/icons");

var _ListAlt = _interopRequireDefault(require("@material-ui/icons/ListAlt"));

var _Reorder = _interopRequireDefault(require("@material-ui/icons/Reorder"));

var _reactDeviceDetect = require("react-device-detect");

var _reactRouterDom = require("react-router-dom");

var _mobileBottomNavigationStyles = _interopRequireDefault(require("./mobileBottomNavigationStyles"));

var _headerContext = require("./headerContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BottomNavigation(_ref) {
  var onClickHome = _ref.onClickHome,
      hasCategories = _ref.hasCategories,
      onClickCategories = _ref.onClickCategories;
  var classes = (0, _mobileBottomNavigationStyles.default)();
  if (hasCategories) return /*#__PURE__*/_react.default.createElement(_headerContext.HeaderContext.Consumer, null, function (_ref2) {
    var state = _ref2.state,
        actions = _ref2.actions;
    return /*#__PURE__*/_react.default.createElement(_core.BottomNavigation, {
      value: state.bottomButton,
      showLabels: true,
      className: _reactDeviceDetect.isIOS13 || _reactDeviceDetect.isIOS ? classes.bottomIOS : classes.bottomWrapper
    }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
      label: /*#__PURE__*/_react.default.createElement("span", {
        className: window.location.pathname !== '/' ? classes.paragraph : classes.paragraphActive
      }, "Cat\xE1logo"),
      icon: /*#__PURE__*/_react.default.createElement(_ListAlt.default, {
        className: window.location.pathname !== '/' ? classes.icon : classes.iconActive
      }),
      onClick: function onClick() {
        onClickHome();
        actions.clickBottomHome();
      },
      classes: {
        root: classes.bottomButtons
      }
    }), /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
      label: "Busca",
      icon: /*#__PURE__*/_react.default.createElement(_icons.SearchSharp, null),
      classes: {
        root: classes.bottomButtons
      },
      onClick: actions.clickBottomSearch
    }), /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
      label: /*#__PURE__*/_react.default.createElement("span", {
        className: !(0, _reactRouterDom.matchPath)(window.location.pathname, {
          path: '/categories'
        }) ? classes.paragraph : classes.paragraphActive
      }, "Categorias"),
      icon: /*#__PURE__*/_react.default.createElement(_Reorder.default, {
        className: !(0, _reactRouterDom.matchPath)(window.location.pathname, {
          path: '/categories'
        }) ? classes.icon : classes.iconActive
      }),
      onClick: function onClick() {
        onClickCategories();
      },
      classes: {
        root: classes.bottomButtons
      }
    }));
  });
  return /*#__PURE__*/_react.default.createElement(_headerContext.HeaderContext.Consumer, null, function (_ref3) {
    var state = _ref3.state,
        actions = _ref3.actions;
    return /*#__PURE__*/_react.default.createElement(_core.BottomNavigation, {
      value: state.bottomButton,
      showLabels: true,
      className: _reactDeviceDetect.isIOS13 || _reactDeviceDetect.isIOS ? classes.bottomIOS : classes.bottomWrapper
    }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
      label: /*#__PURE__*/_react.default.createElement("span", {
        className: window.location.pathname !== '/' ? classes.paragraph : classes.paragraphActive
      }, "In\xEDcio"),
      icon: /*#__PURE__*/_react.default.createElement(_icons.HomeSharp, {
        className: window.location.pathname !== '/' ? classes.icon : classes.iconActive
      }),
      onClick: function onClick() {
        onClickHome();
        actions.clickBottomHome();
      },
      classes: {
        root: classes.bottomButtons
      }
    }), /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
      label: "Busca",
      icon: /*#__PURE__*/_react.default.createElement(_icons.SearchSharp, null),
      classes: {
        root: classes.bottomButtons
      },
      onClick: actions.clickBottomSearch
    }));
  });
}

BottomNavigation.propTypes = {
  onClickHome: _propTypes.default.func.isRequired,
  onClickCategories: _propTypes.default.func.isRequired,
  hasCategories: _propTypes.default.bool
};
BottomNavigation.defaultProps = {
  hasCategories: false
};
var _default = BottomNavigation;
exports.default = _default;